import {Box, Grid, Typography} from "@mui/material";

export function EligibilityCard({content}) {
    return (
        <Grid item xs={12} align='left'>
            <Box width="100%" bgcolor={content.bgColor} padding={1.5} maxWidth="500px" sx={{borderRadius: 1}}>
                <Grid container>
                    <Grid item xs={1.25} sx={{pt: 0.5}}>
                        {content.icon}
                    </Grid>
                    <Grid item xs={10.75}>
                        <Typography variant="h6">
                            <Box fontWeight="fontWeightMedium" display="inline" data-testid="eligibility-status">
                                {content.title}
                            </Box>
                        </Typography>
                        <Typography variant="subtitle2"
                                    data-testid='eligibility-card-content'>{content.body}</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}